
const newModel = () => {
    return {
        quanHuyenId: null,
        ten: null,
        tinhTpId: null,
        tenTinhTp: null,
        stt: null,
        enabled: null,
        enabledDisplay: null,
    }
}

const newFEModel = () => {
    return {
        tinhTpId: null,
        tenTinhTp: null,
        stt: null,
        enabled: null,
        enabledDisplay: null,
    }
}

const fromJson = (item) => {
    return {
        quanHuyenId: item.quanHuyenId,
        ten: item.ten,
        tinhTpId: item.tinhTpId,
        tenTinhTp: item.tenTinhTp,
        stt: item.stt,
        enabled: item.enabled,
        enabledDisplay: item.enabled == 1 ? true : false
    }
}

const parseModeltoFEModel = (item) => {
    return {
        quanHuyenId: item.quanHuyenId,
        ten: item.ten,
        tinhTpId: item.tinhTpId,
        tenTinhTp: item.tenTinhTp,
        stt: item.stt,
        enabled: item.enabled,
        enabledDisplay: item.enabled == 1 ? true : false
    }
}

const errors = () => {
    return {
        quanHuyenId: null,
        ten: null,
        tinhTpId: null,
        tenTinhTp: null,
        stt: null,
        enabled: null,
        enabledDisplay: null
    }
}

export const quanHuyenModel = {
    newModel,
    newFEModel,
    parseModeltoFEModel,
    fromJson,
    errors,
}


